<template>
    <div class="base-card__content channel-content-skeleton"/>
</template>

<style lang="scss">
    @import url("styles.scss");
</style>